import React from 'react';
import { Tooltip } from '@mui/material';
import { Category } from '@mui/icons-material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AccountData, OrderData, OrderStatus, ProjectSelectionMode } from '../api';
import { getOrderPage } from '../utils/AccountUtils';
import { mb } from './theme/mbTokens';

export const PROJECT_SELECTION_PENDING_COLOR = mb.highlight;

const INACTIVE_STATUSES = [OrderStatus.ARCHIVED, OrderStatus.ABANDONED, OrderStatus.CONVERTED_TO_VOUCHER];

export const isProjectSelectionPending = (order: OrderData, account: AccountData): boolean => {
  const projectSelectionMode = getOrderPage(account, order.order_page_id)?.project_selection_config?.mode;
  if (!projectSelectionMode || projectSelectionMode === ProjectSelectionMode.DISABLED) {
    return false;
  }
  if (INACTIVE_STATUSES.includes(order.status)) {
    return false;
  }
  if ((order.extra_items || []).some((line) => line.catalog_item_id)) {
    return false;
  }
  return !order.date || moment(order.date).isSameOrAfter(moment(), 'day');
};

type ProjectSelectionPendingBadgeProps = {
  order: OrderData;
  account: AccountData;
  fontSize?: 'small' | 'medium';
};

export const ProjectSelectionPendingBadge = ({
  order,
  account,
  fontSize = 'small',
}: ProjectSelectionPendingBadgeProps) => {
  const { t } = useTranslation();
  if (!isProjectSelectionPending(order, account)) {
    return null;
  }
  return (
    <Tooltip title={t('calendar.edit_order.order_details.projectNotChosen')} arrow>
      <Category fontSize={fontSize} style={{ color: PROJECT_SELECTION_PENDING_COLOR }} />
    </Tooltip>
  );
};
